
<template>
    <div class="mainContent">
      <h2>Ups! Página no encontrada</h2>
      <a href @click.prevent="$router.push({name: 'home'})">Volver al curso</a>
    </div>
</template>

<script>
  /* eslint-disable */

  export default {
    name: 'NotFound',
  }
</script>

<style lang="scss">

</style>
